import { EWsStatusActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Не удалось подписаться на статус пользователей по вебсокету
 */
export const setSubscribeUsersStatusFailed = actionGenerator<EWsStatusActionTypes.SubscribeFailed, void>(
  EWsStatusActionTypes.SubscribeFailed,
);

/**
 * Удачная подписка на статус пользователей по вебсокету
 */
export const setSubscribeUsersStatusSuccess = actionGenerator<EWsStatusActionTypes.SubscribeSucceed, void>(
  EWsStatusActionTypes.SubscribeSucceed,
);

/**
 * Ожидание подписки на статус пользователей по вебсокету
 */
export const setSubscribeUsersStatusPending = actionGenerator<EWsStatusActionTypes.SubscribePending, void>(
  EWsStatusActionTypes.SubscribePending,
);

/**
 * Не удалось отписаться от статуса пользователей по вебсокету
 */
export const setUnsubscribeUsersStatusFailed = actionGenerator<EWsStatusActionTypes.UnsubscribeFailed, void>(
  EWsStatusActionTypes.UnsubscribeFailed,
);

/**
 * Удачная отписка от статуса пользователей по вебсокету
 */
export const setUnsubscribeUsersStatusSuccess = actionGenerator<EWsStatusActionTypes.UnsubscribeSucceed, void>(
  EWsStatusActionTypes.UnsubscribeSucceed,
);

/**
 * Ожидание отписки от статуса пользователей по вебсокету
 */
export const setUnsubscribeUsersStatusPending = actionGenerator<EWsStatusActionTypes.UnsubscribePending, void>(
  EWsStatusActionTypes.UnsubscribePending,
);
